export default {
  'app.true': '是',
  'app.false': '否',
  'app.403.page': '無此頁面許可權',
  'app.403.page.tip': '如需開通許可權，請聯系管理員',
};
